import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Container,
  Grid,
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Nav from "../components/Nav";
import Footer from "../components/Footer";

const BajaUsuario = () => {
  const [isOpen, setIsOpen] = useState(true);
  const today = new Date().toISOString().split("T")[0];
  const createInitialFormState = () => ({
    nombre: "",
    apellidos: "",
    departamento: "",
    fechaBaja: "",
    observaciones: "",
    firmadoPor: "",
    fechaFirma: new Date().toISOString(),
  });
  const [formData, setFormData] = useState(createInitialFormState());

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!formData.fechaBaja) {
      toast.error("La fecha de baja es obligatoria.");
      return;
    }

    const selectedDate = new Date(formData.fechaBaja);
    const todayDate = new Date();
    selectedDate.setHours(0, 0, 0, 0);
    todayDate.setHours(0, 0, 0, 0);

    if (isNaN(selectedDate.getTime()) || selectedDate < todayDate) {
      toast.error("La fecha de baja no puede ser anterior a la actual.");
      return;
    }

    const replyToEmail = localStorage.getItem("userEmail") || null;
    const replyToName = localStorage.getItem("username") || null;
    const currentFechaFirma = new Date().toISOString();

    const payload = {
      ...formData,
      fechaFirma: currentFechaFirma,
      formType: "bajaUsuario",
      replyToEmail,
      replyToName,
    };

    try {
      const response = await fetch("mail.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (result.success) {
        toast.success(result.message || "Solicitud enviada correctamente.");
        setFormData(createInitialFormState());
      } else {
        toast.error(result.message || "No se pudo enviar la solicitud.");
      }
    } catch (error) {
      toast.error("Error al conectar con el servidor.");
    }
  };

  const firmaDisplayDate = formData.fechaFirma
    ? formData.fechaFirma.split("T")[0]
    : new Date().toISOString().split("T")[0];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        overflowX: "hidden",
      }}
    >
      <Nav isOpen={isOpen} toggleSidebar={() => setIsOpen(!isOpen)} />
      <Container
        maxWidth="md"
        sx={{
          flexGrow: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "80vh",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#fff",
            p: 4,
            borderRadius: 2,
            boxShadow: 2,
            width: "100%",
            maxWidth: "800px",
          }}
        >
          <Typography
            variant="h5"
            gutterBottom
            textAlign="center"
            sx={{ mb: 4 }}
          >
            Baja de Usuario
          </Typography>

          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Nombre"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Apellidos"
                  name="apellidos"
                  value={formData.apellidos}
                  onChange={handleChange}
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Departamento"
                  name="departamento"
                  value={formData.departamento}
                  onChange={handleChange}
                  helperText="Departamento al que pertenece el usuario"
                  required
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  type="date"
                  label="Fecha de baja"
                  name="fechaBaja"
                  value={formData.fechaBaja}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    inputProps: { min: today },
                  }}
                  helperText="Indica la fecha efectiva de la baja"
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Observaciones / Dispositivos a devolver"
                  name="observaciones"
                  value={formData.observaciones}
                  onChange={handleChange}
                  multiline
                  rows={4}
                  helperText="Detalla si debe devolver equipos, accesos o cualquier observacion relevante"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Firmado por"
                  name="firmadoPor"
                  value={formData.firmadoPor}
                  onChange={handleChange}
                  helperText="Responsable que gestiona la baja"
                  required
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  type="date"
                  label="Fecha firma"
                  name="fechaFirma"
                  value={firmaDisplayDate}
                  InputProps={{ readOnly: true }}
                  helperText="Se completa automaticamente con la fecha actual"
                />
              </Grid>
            </Grid>

            <Button
              type="submit"
              variant="contained"
              color="primary"
              sx={{ mt: 3 }}
              fullWidth
            >
              Registrar baja
            </Button>
          </form>
        </Box>
      </Container>
      <Footer />
      <ToastContainer />
    </Box>
  );
};

export default BajaUsuario;
